'use client';
/**
 * Выполняет проверку того, что `subject` является `NaN`.
 *
 * @remarks
 * Производит попытку приведения к `Number` и проверку с помощью `Number.isNaN`.
 *
 * @param subject - Субъект проверки произвольного типа.
 *
 * @stable
 * */ var isNan = function(subject) {
    return Number.isNaN(Number(subject));
};

export { isNan };
